module.exports = __webpack_public_path__ + "media/images/emblems/Bettlach-blason-21ef32d66ee7a2fb401ef81a1dc80301.png";